var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "90%",
            "before-close": _vm.closeDialog,
            "close-on-click-modal": false,
            "custom-class": "sk-dialog",
            top: "1vh",
            title: "Thêm mới nhân viên",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formAllTabEmployee",
              attrs: {
                "label-width": "140px",
                model: _vm.formAllTabEmployee,
                "label-position": "left",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-tabs",
                {
                  attrs: { type: "card" },
                  model: {
                    value: _vm.activeTabName,
                    callback: function ($$v) {
                      _vm.activeTabName = $$v
                    },
                    expression: "activeTabName",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "Thông tin", name: "infoTab" } },
                    [
                      _c(
                        "div",
                        { staticClass: "common-info-tab" },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 24 } },
                            [
                              _c("el-col", { attrs: { span: 6 } }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-sidebar-card" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "profile-avatar-wrap" },
                                      [
                                        _vm.imageUrlPreview
                                          ? _c("el-image", {
                                              staticClass: "profile-avatar",
                                              attrs: {
                                                src: _vm.imageUrlPreview,
                                                fit: "cover",
                                              },
                                            })
                                          : _vm._e(),
                                        _c("el-upload", {
                                          ref: "upload",
                                          staticStyle: { display: "none" },
                                          attrs: {
                                            "show-file-list": false,
                                            "on-change": _vm.toggleUpload,
                                            "on-remove": _vm.handleRemove,
                                            "auto-upload": false,
                                            action: "",
                                          },
                                        }),
                                        !_vm.imageUrlPreview
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "avatar-trigger-area",
                                                on: {
                                                  click:
                                                    _vm.triggerAvatarUpload,
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-plus",
                                                }),
                                                _c("span", [
                                                  _vm._v("Thêm ảnh đại diện"),
                                                ]),
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "avatar-actions-overlay",
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "avatar-action-btn edit-btn",
                                                    attrs: {
                                                      type: "button",
                                                      title: "Thay đổi ảnh",
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.triggerAvatarUpload,
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-edit-outline",
                                                    }),
                                                  ]
                                                ),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "avatar-action-btn delete-btn",
                                                    attrs: {
                                                      type: "button",
                                                      title: "Xóa ảnh",
                                                    },
                                                    on: {
                                                      click: _vm.handleRemove,
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-delete",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "qr-bank-section" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "section-divider" },
                                          [_vm._v("Ảnh QR ngân hàng")]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "qr-container-wrap" },
                                          [
                                            _vm.qrUrlPreview
                                              ? _c("el-image", {
                                                  staticClass: "qr-bank-image",
                                                  attrs: {
                                                    src: _vm.qrUrlPreview,
                                                    fit: "contain",
                                                  },
                                                })
                                              : _vm._e(),
                                            _c("el-upload", {
                                              ref: "uploadQr",
                                              staticStyle: { display: "none" },
                                              attrs: {
                                                "show-file-list": false,
                                                "on-change": _vm.toggleUploadQr,
                                                "on-remove": _vm.handleRemoveQr,
                                                "auto-upload": false,
                                                action: "",
                                              },
                                            }),
                                            !_vm.qrUrlPreview
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "qr-trigger-area",
                                                    on: {
                                                      click:
                                                        _vm.triggerQrUpload,
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-plus",
                                                    }),
                                                    _c("span", [
                                                      _vm._v("Thêm QR"),
                                                    ]),
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "qr-actions-overlay",
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "avatar-action-btn edit-btn",
                                                        attrs: {
                                                          type: "button",
                                                          title: "Thay đổi QR",
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.triggerQrUpload,
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-edit-outline",
                                                        }),
                                                      ]
                                                    ),
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "avatar-action-btn delete-btn",
                                                        attrs: {
                                                          type: "button",
                                                          title: "Xóa QR",
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.handleRemoveQr,
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-delete",
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _c("el-col", { attrs: { span: 9 } }, [
                                _c(
                                  "div",
                                  { staticClass: "info-section-card" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "card-inner-title" },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-user",
                                        }),
                                        _vm._v(" Thông tin nhân sự"),
                                      ]
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "Họ tên",
                                          prop: "createEmployeeMainInfoRequest.fullName",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          model: {
                                            value:
                                              _vm.formAllTabEmployee
                                                .createEmployeeMainInfoRequest
                                                .fullName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formAllTabEmployee
                                                  .createEmployeeMainInfoRequest,
                                                "fullName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formAllTabEmployee.createEmployeeMainInfoRequest.fullName",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      { attrs: { gutter: 16 } },
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "Số điện thoại",
                                                  prop: "createEmployeeMainInfoRequest.phone",
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  model: {
                                                    value:
                                                      _vm.formAllTabEmployee
                                                        .createEmployeeMainInfoRequest
                                                        .phone,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formAllTabEmployee
                                                          .createEmployeeMainInfoRequest,
                                                        "phone",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formAllTabEmployee.createEmployeeMainInfoRequest.phone",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  prop: "createEmployeeMainInfoRequest.gender",
                                                  label: "Giới tính",
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-radio-group",
                                                  {
                                                    staticClass:
                                                      "gender-radio-group",
                                                    model: {
                                                      value:
                                                        _vm.formAllTabEmployee
                                                          .createEmployeeMainInfoRequest
                                                          .gender,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.formAllTabEmployee
                                                            .createEmployeeMainInfoRequest,
                                                          "gender",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "formAllTabEmployee.createEmployeeMainInfoRequest.gender",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-radio-button",
                                                      {
                                                        attrs: { label: "Nam" },
                                                      },
                                                      [_vm._v("Nam")]
                                                    ),
                                                    _c(
                                                      "el-radio-button",
                                                      {
                                                        attrs: { label: "Nữ" },
                                                      },
                                                      [_vm._v("Nữ")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      { attrs: { gutter: 16 } },
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "Ngày sinh",
                                                  prop: "createEmployeeMainInfoRequest.birthday",
                                                },
                                              },
                                              [
                                                _c("el-date-picker", {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    clearable: false,
                                                    format: "dd-MM-yyyy",
                                                    "picker-options":
                                                      _vm.pickerOptions,
                                                    "value-format":
                                                      "yyyy-MM-dd",
                                                    type: "date",
                                                    placeholder:
                                                      "Chọn ngày sinh",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formAllTabEmployee
                                                        .createEmployeeMainInfoRequest
                                                        .birthday,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formAllTabEmployee
                                                          .createEmployeeMainInfoRequest,
                                                        "birthday",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formAllTabEmployee.createEmployeeMainInfoRequest.birthday",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "Dân tộc",
                                                  prop: "createEmployeeMainInfoRequest.ethnic",
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: { clearable: "" },
                                                  model: {
                                                    value:
                                                      _vm.formAllTabEmployee
                                                        .createEmployeeMainInfoRequest
                                                        .ethnic,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formAllTabEmployee
                                                          .createEmployeeMainInfoRequest,
                                                        "ethnic",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formAllTabEmployee.createEmployeeMainInfoRequest.ethnic",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "Email",
                                          prop: "createEmployeeMainInfoRequest.email",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          model: {
                                            value:
                                              _vm.formAllTabEmployee
                                                .createEmployeeMainInfoRequest
                                                .email,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formAllTabEmployee
                                                  .createEmployeeMainInfoRequest,
                                                "email",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formAllTabEmployee.createEmployeeMainInfoRequest.email",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      { attrs: { gutter: 16 } },
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  prop: "createEmployeeMainInfoRequest.cmnd",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: { slot: "label" },
                                                    slot: "label",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                          Số định danh\n                          "
                                                    ),
                                                    _c(
                                                      "el-tooltip",
                                                      {
                                                        staticClass: "item",
                                                        attrs: {
                                                          effect: "dark",
                                                          content:
                                                            "Số định danh của nhân sự",
                                                          placement: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-info",
                                                        }),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c("el-input", {
                                                  model: {
                                                    value:
                                                      _vm.formAllTabEmployee
                                                        .createEmployeeMainInfoRequest
                                                        .cmnd,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formAllTabEmployee
                                                          .createEmployeeMainInfoRequest,
                                                        "cmnd",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formAllTabEmployee.createEmployeeMainInfoRequest.cmnd",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "Ngày cấp",
                                                  prop: "createEmployeeMainInfoRequest.cmndDate",
                                                },
                                              },
                                              [
                                                _c("el-date-picker", {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    format: "dd-MM-yyyy",
                                                    "value-format":
                                                      "yyyy-MM-dd",
                                                    type: "date",
                                                    placeholder:
                                                      "Chọn ngày cấp",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formAllTabEmployee
                                                        .createEmployeeMainInfoRequest
                                                        .cmndDate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formAllTabEmployee
                                                          .createEmployeeMainInfoRequest,
                                                        "cmndDate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formAllTabEmployee.createEmployeeMainInfoRequest.cmndDate",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "section-divider",
                                        staticStyle: { margin: "16px 0 12px" },
                                      },
                                      [_vm._v("Tài khoản nhận lương")]
                                    ),
                                    _c(
                                      "el-row",
                                      { attrs: { gutter: 16 } },
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              { attrs: { label: "Ngân hàng" } },
                                              [
                                                _c("el-input", {
                                                  model: {
                                                    value:
                                                      _vm.formAllTabEmployee
                                                        .createEmployeeMainInfoRequest
                                                        .nameBank,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formAllTabEmployee
                                                          .createEmployeeMainInfoRequest,
                                                        "nameBank",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formAllTabEmployee.createEmployeeMainInfoRequest.nameBank",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "Số tài khoản",
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: { type: "number" },
                                                  model: {
                                                    value:
                                                      _vm.formAllTabEmployee
                                                        .createEmployeeMainInfoRequest
                                                        .bankAccountNumber,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formAllTabEmployee
                                                          .createEmployeeMainInfoRequest,
                                                        "bankAccountNumber",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formAllTabEmployee.createEmployeeMainInfoRequest.bankAccountNumber",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("el-col", { attrs: { span: 9 } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "info-section-card parent-card",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "card-inner-title" },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-suitcase-1",
                                        }),
                                        _vm._v(
                                          " Thông tin công việc & Hôn nhân"
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-row",
                                      { attrs: { gutter: 16 } },
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "Ngày vào",
                                                  prop: "createEmployeeMainInfoRequest.startDate",
                                                },
                                              },
                                              [
                                                _c("el-date-picker", {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    type: "date",
                                                    format: "dd-MM-yyyy",
                                                    "value-format":
                                                      "yyyy-MM-dd",
                                                    placeholder:
                                                      "Chọn ngày vào",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formAllTabEmployee
                                                        .createEmployeeMainInfoRequest
                                                        .startDate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formAllTabEmployee
                                                          .createEmployeeMainInfoRequest,
                                                        "startDate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formAllTabEmployee.createEmployeeMainInfoRequest.startDate",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "Ngày ký hợp đồng",
                                                  prop: "createEmployeeMainInfoRequest.contractDate",
                                                },
                                              },
                                              [
                                                _c("el-date-picker", {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    type: "date",
                                                    format: "dd-MM-yyyy",
                                                    "value-format":
                                                      "yyyy-MM-dd",
                                                    placeholder: "Chọn ngày",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formAllTabEmployee
                                                        .createEmployeeMainInfoRequest
                                                        .contractDate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formAllTabEmployee
                                                          .createEmployeeMainInfoRequest,
                                                        "contractDate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formAllTabEmployee.createEmployeeMainInfoRequest.contractDate",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      { attrs: { gutter: 16 } },
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "Ngày hết hạn",
                                                  prop: "createEmployeeMainInfoRequest.endDate",
                                                },
                                              },
                                              [
                                                _c("el-date-picker", {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    type: "date",
                                                    format: "dd-MM-yyyy",
                                                    "value-format":
                                                      "yyyy-MM-dd",
                                                    placeholder: "Ngày hết hạn",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formAllTabEmployee
                                                        .createEmployeeMainInfoRequest
                                                        .endDate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formAllTabEmployee
                                                          .createEmployeeMainInfoRequest,
                                                        "endDate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formAllTabEmployee.createEmployeeMainInfoRequest.endDate",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "Trình độ",
                                                  prop: "createEmployeeMainInfoRequest.educationLevel",
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  model: {
                                                    value:
                                                      _vm.formAllTabEmployee
                                                        .createEmployeeMainInfoRequest
                                                        .educationLevel,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formAllTabEmployee
                                                          .createEmployeeMainInfoRequest,
                                                        "educationLevel",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formAllTabEmployee.createEmployeeMainInfoRequest.educationLevel",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      { attrs: { gutter: 16 } },
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "Đối tượng",
                                                  prop: "createEmployeeMainInfoRequest.idAccountTypeList",
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticStyle: {
                                                      width: "100%",
                                                    },
                                                    attrs: {
                                                      multiple: "",
                                                      placeholder:
                                                        "Chọn đối tượng",
                                                      clearable: "",
                                                      filterable: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.formAllTabEmployee
                                                          .createEmployeeMainInfoRequest
                                                          .idAccountTypeList,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.formAllTabEmployee
                                                            .createEmployeeMainInfoRequest,
                                                          "idAccountTypeList",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "formAllTabEmployee.createEmployeeMainInfoRequest.idAccountTypeList",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.accountTypeList,
                                                    function (item) {
                                                      return _c("el-option", {
                                                        key: item.id,
                                                        attrs: {
                                                          value: item.id,
                                                          label: item.name,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "Hôn nhân",
                                                  prop: "createEmployeeMainInfoRequest.marriedStatus",
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticStyle: {
                                                      width: "100%",
                                                    },
                                                    attrs: {
                                                      filterable: "",
                                                      clearable: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.formAllTabEmployee
                                                          .createEmployeeMainInfoRequest
                                                          .marriedStatus,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.formAllTabEmployee
                                                            .createEmployeeMainInfoRequest,
                                                          "marriedStatus",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "formAllTabEmployee.createEmployeeMainInfoRequest.marriedStatus",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.options,
                                                    function (item) {
                                                      return _c("el-option", {
                                                        key: item.value,
                                                        attrs: {
                                                          label: item.label,
                                                          value: item.value,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      { attrs: { gutter: 16 } },
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 24 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "Số con",
                                                  prop: "createEmployeeMainInfoRequest.numberChildren",
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  model: {
                                                    value:
                                                      _vm.formAllTabEmployee
                                                        .createEmployeeMainInfoRequest
                                                        .numberChildren,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formAllTabEmployee
                                                          .createEmployeeMainInfoRequest,
                                                        "numberChildren",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formAllTabEmployee.createEmployeeMainInfoRequest.numberChildren",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "Địa chỉ thường trú",
                                          prop: "createEmployeeMainInfoRequest.permanentAddress",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          model: {
                                            value:
                                              _vm.formAllTabEmployee
                                                .createEmployeeMainInfoRequest
                                                .permanentAddress,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formAllTabEmployee
                                                  .createEmployeeMainInfoRequest,
                                                "permanentAddress",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formAllTabEmployee.createEmployeeMainInfoRequest.permanentAddress",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "Chỗ ở hiện tại",
                                          prop: "createEmployeeMainInfoRequest.address",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          model: {
                                            value:
                                              _vm.formAllTabEmployee
                                                .createEmployeeMainInfoRequest
                                                .address,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formAllTabEmployee
                                                  .createEmployeeMainInfoRequest,
                                                "address",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formAllTabEmployee.createEmployeeMainInfoRequest.address",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "Ghi chú",
                                          prop: "createEmployeeMainInfoRequest.note",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "100%" },
                                          attrs: { type: "textarea", rows: 1 },
                                          model: {
                                            value:
                                              _vm.formAllTabEmployee
                                                .createEmployeeMainInfoRequest
                                                .note,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formAllTabEmployee
                                                  .createEmployeeMainInfoRequest,
                                                "note",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formAllTabEmployee.createEmployeeMainInfoRequest.note",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "Phòng ban", name: "departmentTab" } },
                    [
                      _c(
                        "div",
                        { staticClass: "table-content row-data" },
                        [
                          _c(
                            "el-table",
                            {
                              attrs: {
                                "highlight-current-row": "",
                                data: _vm.formAllTabEmployee
                                  .tabDepartmentInEmployee,
                                "header-cell-style": _vm.tableHeaderColor,
                                "max-height": _vm.$tableMaxHeight,
                                border: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  type: "index",
                                  label: "STT",
                                  width: "50",
                                  align: "center",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "departmentName",
                                  label: "Tên phòng ban",
                                  align: "center",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Chọn phòng ban",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-checkbox", {
                                          on: {
                                            change: function ($event) {
                                              return _vm.selectionMultiDepartment(
                                                scope.$index,
                                                scope.row
                                              )
                                            },
                                          },
                                          model: {
                                            value: scope.row.checkDepartment,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "checkDepartment",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.checkDepartment",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: { label: "Chức vụ", align: "center" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "Điền chức vụ",
                                          },
                                          model: {
                                            value: scope.row.position,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "position",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.position",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "Chuyên môn", name: "professionalTab" } },
                    [
                      _c(
                        "div",
                        { staticClass: "table-content row-data" },
                        [
                          _c(
                            "el-table",
                            {
                              attrs: {
                                "highlight-current-row": "",
                                data: _vm.formAllTabEmployee
                                  .tabProfessionalInEmployee,
                                "header-cell-style": _vm.tableHeaderColor,
                                "max-height": _vm.$tableMaxHeight,
                                border: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  type: "index",
                                  label: "STT",
                                  width: "50",
                                  align: "center",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "className",
                                  label: "Tên Lớp",
                                  align: "center",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: { label: "Lớp dạy", align: "center" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-checkbox", {
                                          on: {
                                            change: function ($event) {
                                              return _vm.selectionMultiProfessional(
                                                scope.$index,
                                                scope.row
                                              )
                                            },
                                          },
                                          model: {
                                            value: scope.row.checkIsClass,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "checkIsClass",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.checkIsClass",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: { label: "Chủ nhiệm", align: "center" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.checkIsClass
                                          ? _c("el-checkbox", {
                                              model: {
                                                value: scope.row.isMaster,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "isMaster",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.isMaster",
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: { label: "Chọn môn", align: "center" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.checkIsClass
                                          ? _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  placeholder: "Chọn môn học",
                                                  multiple: "",
                                                },
                                                model: {
                                                  value:
                                                    scope.row.listIdSubject,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "listIdSubject",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.listIdSubject",
                                                },
                                              },
                                              _vm._l(
                                                scope.row.subjectResponseList,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.id,
                                                    attrs: {
                                                      label: item.subjectName,
                                                      value: item.id,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          : _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  disabled: "",
                                                  placeholder: "Chọn môn học",
                                                  multiple: "",
                                                },
                                                model: {
                                                  value:
                                                    scope.row.listIdSubject,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "listIdSubject",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.listIdSubject",
                                                },
                                              },
                                              _vm._l(
                                                scope.row.subjectResponseList,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.id,
                                                    attrs: {
                                                      label: item.subjectName,
                                                      value: item.id,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                          _c("br"),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { name: "appTeacherTab", label: "App Teacher" } },
                    [
                      _c(
                        "el-table",
                        {
                          staticClass: "table-icon-1",
                          attrs: {
                            border: "",
                            data: _vm.teacherIconAppCreate.teacherIconCreate1,
                            "highlight-current-row": "",
                            "header-cell-style": _vm.tableHeaderColor,
                            "max-height": _vm.$tableMaxHeight,
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { type: "index", label: "STT" },
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "iconName", label: "Chức năng" },
                          }),
                          _c("el-table-column", {
                            attrs: { label: "Hiển thị", align: "center" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-checkbox", {
                                      model: {
                                        value: scope.row.statusShow,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "statusShow", $$v)
                                        },
                                        expression: "scope.row.statusShow",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "Mở khóa", align: "center" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.rootLockStatus
                                      ? _c("el-checkbox", {
                                          model: {
                                            value: scope.row.status,
                                            callback: function ($$v) {
                                              _vm.$set(scope.row, "status", $$v)
                                            },
                                            expression: "scope.row.status",
                                          },
                                        })
                                      : _c("el-checkbox", {
                                          attrs: { disabled: "" },
                                        }),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-table",
                        {
                          staticClass: "table-icon-2",
                          attrs: {
                            border: "",
                            data: _vm.teacherIconAppCreate.teacherIconCreate2,
                            "highlight-current-row": "",
                            "header-cell-style": _vm.tableHeaderColor,
                            "max-height": _vm.$tableMaxHeight,
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { type: "index", label: "STT" },
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "iconName", label: "Chức năng" },
                          }),
                          _c("el-table-column", {
                            attrs: { label: "Hiển thị", align: "center" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-checkbox", {
                                      model: {
                                        value: scope.row.statusShow,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "statusShow", $$v)
                                        },
                                        expression: "scope.row.statusShow",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "Mở khóa", align: "center" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.rootLockStatus
                                      ? _c("el-checkbox", {
                                          model: {
                                            value: scope.row.status,
                                            callback: function ($$v) {
                                              _vm.$set(scope.row, "status", $$v)
                                            },
                                            expression: "scope.row.status",
                                          },
                                        })
                                      : _c("el-checkbox", {
                                          attrs: { disabled: "" },
                                        }),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "tab-infor-button sk-dialog-footer" },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-cancel",
                  attrs: { type: "danger", size: "medium" },
                  on: {
                    click: function ($event) {
                      return _vm.closeDialogByButton("formAllTabEmployee")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-close" }),
                  _c("span", [_vm._v("Đóng")]),
                ]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn-save",
                  attrs: {
                    type: "success",
                    size: "medium",
                    loading: _vm.loadingButton,
                    mini: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("formAllTabEmployee")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-check" }),
                  _c("span", [_vm._v("Lưu")]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }